import { Directive, Input, OnInit, Self } from '@angular/core';
import { AbstractControl } from '@angular/forms';
import { NgxMatDatetimepicker } from '@angular-material-components/datetime-picker';

/**
 * When the datetime picker is opened while its control is empty, preselects the current date & time.
 * The value must be set before the overlay is created (the actions row clones the selection model on open),
 * so `open()` is wrapped to cover every entry point (input click, toggle button, keyboard).
 */
@Directive({ selector: 'ngx-mat-datetime-picker[eboOpenAtNow]' })
export class DatetimePickerOpenNowDirective implements OnInit {
  @Input('eboOpenAtNow') control: AbstractControl;

  constructor(@Self() private picker: NgxMatDatetimepicker<any>) {}

  ngOnInit(): void {
    const open = this.picker.open.bind(this.picker);
    this.picker.open = () => {
      if (this.control && !this.control.value && !this.picker.opened) {
        this.control.setValue(new Date());
      }
      open();
    };
  }
}
